module.exports = __webpack_public_path__ + "img/portable-ssd-t-7-touch-2-tb-2-copy@2x.dcdc8cd2.png";